//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GiftCardForm from "@/components/shop/conf/GiftCardForm";

export default {
  name: "GiftCardControls",
  components: {
    GiftCardForm
  },
  props: {
    amountError: {
      type: Boolean,
      default: false
    },
    giftCardExpansionPanels: {
      type: Number,
      default: null
    },
  },
  inject: [
    'giftCardAmountList',
    'giftCardData'
  ],
  computed: {
    expansionPanels: {
      get () { return this.giftCardExpansionPanels },
      set (value) { this.$emit('update:giftCardExpansionPanels', value) }
    }
  },
  methods: {
    setAmount(amount) {
      this.giftCardData.giftcard_amount = amount;
    }
  }
}
